import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';
import type { Action, NodeEditorTab } from '~/dashboard/views/workflows/store/engine/types';

import type { FormAdapterMap, FormKey } from './types';

import { inputAttributeConfigurationFormAdapter } from '../AttributeConfiguration/InputAttributeConfigurationTab/helpers';
import { matrixOptionsFormAdapter } from '../MatrixOptionsTab/helpers';
import { serviceLocalSettingFormAdapter } from '../ServiceTabs/serviceLocalSettingHelpers';
import { outputAttributeExpressionFormAdapter } from '../OutputAttributeExpressionTab/helpers';
import { outputAttributeOptionsFormAdapter } from '../AttributeConfiguration/OutputAttributeOptionsTab/helpers';
import { serviceOptionsFormAdapter } from '../ServiceTabs/serviceOptionHelpers';
import { tagGlobalSettingsFormAdapter } from '../TagGlobalSettingsTab/helpers';
import { tagLocalSettingsFormAdapter } from '../TagLocalSettingsTab/helpers';
/**
 * Map with all adapters for a the supported action type + tab combinations
 */
const formAdapterMap: FormAdapterMap = {
  [getActionTabKey(ActionType.INPUT, 'configuration')]: inputAttributeConfigurationFormAdapter,
  [getActionTabKey(ActionType.MATRIX_MODEL, 'options')]: matrixOptionsFormAdapter,
  [getActionTabKey(ActionType.OUTPUT, 'options')]: outputAttributeOptionsFormAdapter,
  [getActionTabKey(ActionType.OUTPUT, 'rule')]: outputAttributeExpressionFormAdapter,
  [getActionTabKey(ActionType.SERVICE, 'options')]: serviceOptionsFormAdapter,
  [getActionTabKey(ActionType.SERVICE, 'configuration')]: serviceLocalSettingFormAdapter, // TODO: update it to 'options' once we clean out the legacy service options
  [getActionTabKey(ActionType.TAG, 'configuration')]: tagGlobalSettingsFormAdapter,
  [getActionTabKey(ActionType.TAG, 'options')]: tagLocalSettingsFormAdapter,
  // add other form adapters here
};

export function getFormAdapter(action: Action, tab: NodeEditorTab) {
  return formAdapterMap[getActionTabKey(action?.type, tab)];
}

export function getActionTabKey(actionType: ActionType, tab: NodeEditorTab): FormKey {
  return `${actionType}--${tab}`;
}
